import "../../../../GesagtGetan.Basic/Resources/Private/Assets/Variables/createNamespace";
import { domReady } from "../../../../GesagtGetan.Basic/Resources/Private/Assets/Helper";

import "./Main.scss";
import "../Fusion/Component/Header";

domReady(function() {
    _gg.onReadyRun();
});
